// component.vue carries TWO stylesheets: style.css (scoped — the page container) and
// global.css (NOT scoped — `.custom-dialog` has to reach the loading dialog's teleported
// overlay, and `.dp__theme_dark` the datepicker's own elements). Its stock CSS travels
// with the <Datepicker> tag it styles, and still loads after the chart packages and ItemsGrid.
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import { BaseTimeSeriesChart } from '@rdrive/plugin-chart-time-series';
import { ItemsGrid } from '@rdrive/plugin-items-grid';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import setup from './setup.js';

export default {
  name: 'activity-page',
  components: { StackedHorizontalBarChart, BaseTimeSeriesChart, ItemsGrid, Datepicker },
  setup,
};
